//Removes "Vanguard" from text string
//Example: "Vanguard Total Stock Market ETF" returns "Total Stock Market ETF"
export default function removeVgText(value) {
	return value ? value.replace(/Vanguard /gi, "") : "";
}
